import { Link, useNavigate } from "react-router-dom";
import { Body, Inputs, NovaCategoriaContainer } from "./styles";
import { toast } from "react-toastify";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../../../providers/Auth/index";
import { CampoObrigatorio } from "../../../../schemas/novoCadastro";
import { ReactSVG } from "react-svg";
import voltar from "../../../../assets/voltar.svg";

const NovaMarca = () => {
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm({
    resolver: yupResolver(CampoObrigatorio),
  });
  const navigate = useNavigate();
  const { user } = useAuth();

  const onSubmitFunction = (data) => {
    const marcas = [data];
    api
      .post("/marcas", { marcas })
      .then((response) => {
        navigate("/marcas");
        toast.success("Item cadastrado com sucesso!");
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  return (
    <NovaCategoriaContainer onSubmit={handleSubmit(onSubmitFunction)}>
      <div className="box">
        <div className="flex">
          <ReactSVG
            onClick={() => navigate("/marcas")}
            className="voltar"
            src={voltar}
          />
          <div>
            <h1>Marcas</h1>
            <span className="underline">Nova Marca</span>
          </div>
        </div>

        <Body>
          <div className="checkbox">
            <input
              type="checkbox"
              id="checkbox1"
              name="status"
              {...register("status")}
              defaultChecked={true}
            />

            <label htmlFor="checkbox1">Ativo</label>
          </div>
          <Inputs>
            <div>
              <label>Nome*</label>
              <input
                type="text"
                name="nome"
                {...register("nome")}
                placeholder="Nome da marca"
              />
              {errors.nome && (
                <span className="input-error-cadastro">
                  {errors.nome.message}
                </span>
              )}
            </div>
          </Inputs>
        </Body>
        <div className="buttons">
          {user && user.permissoes.includes("itens_criar") && (
            <button type="submit">Salvar</button>
          )}
        </div>
      </div>
    </NovaCategoriaContainer>
  );
};

export default NovaMarca;
